import { get } from 'axios';
import { EXPERT_SEMINAR_API_URL } from '../config/constants';

// eslint-disable-next-line
export const getExpertSeminar = slug => {
  return get(`${EXPERT_SEMINAR_API_URL}${slug}/`).then((res) => res.data);
};
